import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as appActions from './actions/app-actions';
import Track from './Track';

class History extends Component {

  render(){
    return (
      <div className="History">
        <h1>Recently Played</h1>
        { this.props.history.map(function(track, i){
          return (
            <Track oddEven={ i % 2 ? 'even' : 'odd' } { ...track } key={ i } />
          );
        }) }
      </div>
    );
  }
}

function mapStateToProps(state, props){
  return {
    history: state.app.history.toJS()
  }
}

function mapDispatchToProps(dispatch){
  return {
    actions: bindActionCreators(appActions, dispatch)
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(History);



// WEBPACK FOOTER //
// ./src/History.js